module.exports = __webpack_public_path__ + "static/img/5.cd76847.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/5.png
// module id = w/62
// module chunks = 45